// Generated by CoffeeScript 1.12.7
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

define('models/question',['require','underscore','backbone'],function(require) {
  var Model, Question, _;
  _ = require('underscore');
  Model = require('backbone').Model;
  return Question = (function(superClass) {
    extend(Question, superClass);

    function Question() {
      return Question.__super__.constructor.apply(this, arguments);
    }

    Question.prototype.idAttribute = "_id";

    Question.prototype.urlRoot = function() {
      return GLOBALS.uris.api + "/question";
    };

    Question.prototype.defaults = {
      title: '',
      subtitle: '',
      required: false,
      comments: null,
      branching: [],
      properties: {},
      meta: {}
    };

    Question.prototype.initialize = function() {};

    return Question;

  })(Model);
});

